import { Button, Grid } from '@mui/material';
import React from 'react';
import { FormikValues, useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { dashboardElementsOptions } from '../constants/dashboardConstants';
import { newDashboardElementFormValidationSchema } from '../validations/newDashboardElementFormValidationSchema';
import AddNewElementSelect from '../components/dropdownSelects/addNewElementSelect';
import SecondaryButton from '../components/buttons/secondaryButton';
import PrimaryButton from '../components/buttons/primaryButton';

interface DashboardsFormInterface {
  selectedDashboard?: number,
  closeDialog: () => void,
  updateLayout: (_newLayout: any) => void,
  isUpdatingLayout: boolean,
  selectedDashboardData: any,
}

const AddDashboardElementForm: React.FC<DashboardsFormInterface> = (props) => {
  const { t } = useTranslation();
  const currentLayout = JSON.parse(props.selectedDashboardData?.data?.layout);

  const formik: FormikValues = useFormik({
    initialValues: {
      id: props.selectedDashboard,
      element: '',
    },
    validationSchema: () => newDashboardElementFormValidationSchema(t),
    onSubmit: async (values: any) => {
      const updatedLayout = [
        ...currentLayout,
        {
          i: values.element,
          x: 0,
          y: 0,
          w: dashboardElementsOptions[values.element].w,
          h: dashboardElementsOptions[values.element].h,
        },
      ];
      await props.updateLayout(updatedLayout);
      props.closeDialog();
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid
        container
        sx={{
          display: 'flex',
          columnGap: '3rem',
          rowGap: '2.5rem',
          paddingBlock: '1rem',
          minWidth: '225px',
        }}
      >
        <Grid item xs={12} marginX="auto" className="relative">
          <AddNewElementSelect formik={formik} layout={currentLayout} />
        </Grid>
        {formik.values.element && (
          <div className="mx-auto h-full max-w-[500px] rounded-lg">
            <img
              className="max-h-[300px] w-full rounded-lg object-contain"
              src={dashboardElementsOptions[formik.values.element].img}
              alt=""
            />
          </div>
        )}
      </Grid>
      <div className="ml-auto mt-5 flex w-fit gap-3">
        <SecondaryButton type="button" onClick={props.closeDialog} dataCy="add-dashboard-element-form-cancel">
          {t('cancel')}
        </SecondaryButton>
        <PrimaryButton type="submit" disabled={props.isUpdatingLayout} dataCy="add-dashboard-element-form-submit">
          {t('submit')}
        </PrimaryButton>
      </div>
    </form>
  );
};

export default AddDashboardElementForm;
